import { Shield, Sparkles, Clock, Leaf } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const REASONS = [
  {
    Icon: Sparkles,
    title: "Detail Obsessed",
    desc: "Baseboards, blinds, grout, light fixtures — the touches lesser crews skip.",
  },
  {
    Icon: Shield,
    title: "Fully Insured",
    desc: "General liability + bonded crews. Protected from the first step inside.",
  },
  {
    Icon: Clock,
    title: "On-Time, Every Time",
    desc: "Window-based arrivals with text alerts. Your schedule, not ours.",
  },
  {
    Icon: Leaf,
    title: "Eco-Conscious Products",
    desc: "Hospital-grade where it matters, plant-based where it doesn't. Safer for kids, pets, and offices.",
  },
];

export const WhyChooseUs = () => (
  <section className="py-24 lg:py-32 bg-[#050505] relative overflow-hidden">
    <div className="absolute top-1/2 -translate-y-1/2 left-0 w-px h-2/3 bg-gradient-to-b from-transparent via-[#D4AF37]/30 to-transparent" />
    <div className="absolute top-1/2 -translate-y-1/2 right-0 w-px h-2/3 bg-gradient-to-b from-transparent via-[#D4AF37]/30 to-transparent" />

    <div className="max-w-7xl mx-auto px-6 lg:px-12">
      <div className="text-center max-w-2xl mx-auto mb-16">
        <div className="overline text-[#D4AF37] mb-4">Why Premier</div>
        <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-white leading-tight">
          The difference is in
          <br />
          <span className="gold-grad-text italic">the details.</span>
        </h2>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {REASONS.map((r, i) => (
          <div
            key={r.title}
            className="card-surface rounded-2xl p-7 group fade-up"
            style={{ animationDelay: `${i * 100}ms` }}
          >
            <div className="h-14 w-14 rounded-2xl bg-gradient-to-br from-[#D4AF37]/15 to-transparent border border-[#D4AF37]/30 flex items-center justify-center mb-6 transition-transform group-hover:scale-110">
              <r.Icon size={22} strokeWidth={1.3} className="text-[#D4AF37]" />
            </div>
            <h3 className="font-serif-display text-xl text-white">{r.title}</h3>
            <p className="text-white/60 text-sm mt-3 leading-relaxed">{r.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
